import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import it from './it.json';
import en from './en.json';
import de from './de.json';

export const staticResources = {
  it: { translation: it },
  en: { translation: en },
  de: { translation: de },
} as const;

export const initializeI18n = () =>
  i18n.use(initReactI18next).init({
    resources: staticResources,
    lng: 'it',
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false,
    },
  });

void initializeI18n();

export default i18n;
